import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import Link from "../../link";

@JsonObject()
export class MenuItem {
    @JsonProperty("id")
    id: number;

    @JsonProperty("name")
    name: string;

    @JsonProperty("title")
    title: string;

    @JsonProperty("icon")
    icon: string;

    @JsonProperty("active")
    isActive: boolean = false;

    @JsonProperty("relativeurl")
    relativeUrl: string;

    @JsonProperty("url")
    url: Link;

    @JsonProperty("disable_menu")
    disableMenu: boolean = false;

    @JsonProperty("items")
    @JsonElementType(MenuItem)
    items: Array<MenuItem> = [];
}
